import { ShieldCheck, Star, Heart } from "lucide-react";
import { Reveal } from "./Motion";

const BADGES = [
  { icon: ShieldCheck, title: "Tecnologia segura" },
  { icon: Star, title: "Atendimento personalizado" },
  { icon: Heart, title: "Mais autoestima e bem-estar" },
];

export const Trust = () => (
  <section aria-label="Diferenciais da Aisla Studio" className="border-y border-[#B8654F]/20 bg-[#FFFDF9]" data-testid="trust-section">
    <ul className="mx-auto grid max-w-[1400px] divide-y divide-[#B8654F]/20 px-5 sm:grid-cols-3 sm:divide-x sm:divide-y-0 sm:px-8 lg:px-12">
      {BADGES.map((b, i) => {
        const Icon = b.icon;
        return (
          <Reveal as="li" key={b.title} delay={0.1 * i} className="flex items-center gap-5 py-8 sm:justify-center sm:px-6" data-testid={`trust-badge-${i + 1}`}>
            <span className="grid h-14 w-14 shrink-0 place-items-center rounded-full border border-[#B8654F]/50 text-[#9A4A38]">
              <Icon className="h-6 w-6" aria-hidden="true" />
            </span>
            <span className="text-sm font-semibold uppercase tracking-[0.2em] text-[#2D1C18]">{b.title}</span>
          </Reveal>
        );
      })}
    </ul>
  </section>
);
